import "./OptionContentWrapper.css";

const OptionContentWrapper = (props) => {
  return <div className="option-content-wrapper">{props.children}</div>;
};

export default OptionContentWrapper;
